import { ButtonV3, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import Motion from '@/app/components/Motion';
import SectionHeading from '@/app/components/SectionHeading';

export interface PopCompareModelsContentProps {
  readonly copy: MessageKey;
  readonly onCtaClick: () => void;
  readonly title: MessageKey;
}

const PopCompareModelsContent = ({
  copy,
  onCtaClick,
  title,
}: PopCompareModelsContentProps): JSX.Element => {
  const t = useTranslations();

  return (
    <div className="flex h-full flex-col justify-center">
      <SectionHeading
        animated
        className="mb-6"
        content={title}
        typographyProps={{
          className: 'leading-tighter text-current font-normal',
          Element: 'h2',
          variant: 'h4',
        }}
      />
      <Motion
        initial={{ opacity: 0 }}
        transition={{ delay: 0.35, duration: 0.75, type: 'tween' }}
        viewport={{ once: true }}
        whileInView={{ opacity: 1 }}
      >
        <TypographyV3 className="mb-6">{t(copy)}</TypographyV3>
        <ButtonV3
          data-cy="pop-compare-models-cta"
          onClick={onCtaClick}
          variant="secondary-dark"
        >
          {t('compare_oura_ring_models')}
        </ButtonV3>
      </Motion>
    </div>
  );
};

export default PopCompareModelsContent;
